import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider } from './context/AuthContext';
import { PetProvider } from './context/PetContext';
import { CatalogProvider } from './context/CatalogContext';
import { ViewModeProvider } from './context/ViewModeContext';
import Navbar from './components/Navbar';
import TreatsBanner from './components/treats/TreatsBanner';
import Home from './pages/Home';
import Catalog from './pages/Catalog';
import CatalogPetView from './pages/CatalogPetView';
import CatalogCosmeticView from './pages/CatalogCosmeticView';
import Login from './pages/Login';
import Kennel from './pages/Kennel';
import PetView from './pages/PetView';
import Cosmetics from './pages/Cosmetics';
import Chat from './pages/Chat';
import Abilities from './pages/Abilities';
import Shop from './pages/Shop';
import About from './pages/About';
import Profile from './pages/Profile';
import AuthCallback from './pages/AuthCallback';
import Privacy from './pages/Privacy';
import Support from './pages/Support';
import Clip from './pages/Clip';
import Terms from './pages/Terms';
import NotFound from './pages/NotFound';
import ErrorBoundary from './components/ErrorBoundary';
import './styles/theme.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
    <ViewModeProvider>
    <CatalogProvider>
    <AuthProvider>
      <PetProvider>
        <Router>
          <ScrollToTop />
          <Navbar />
          <TreatsBanner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/catalog/pet/:id" element={<CatalogPetView />} />
            <Route path="/catalog/cosmetic/:id" element={<CatalogCosmeticView />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/pets" element={<Kennel />} />
            <Route path="/pets/:slot" element={<PetView />} />
            <Route path="/pets/:slot/cosmetics" element={<Cosmetics />} />
            <Route path="/pets/:slot/chat" element={<Chat />} />
            <Route path="/pets/:slot/abilities" element={<Abilities />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/support" element={<Support />} />
            <Route path="/clip" element={<Clip />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </PetProvider>
    </AuthProvider>
    </CatalogProvider>
    </ViewModeProvider>
    </ErrorBoundary>
  );
}

export default App;
